import { MonitorPlay } from 'lucide-react';
import { Button } from '@/client/components/ui/button';
import { PLAYER_BASE_URL } from '@/client/config';

interface PlayerButtonProps {
  /** Pre-built player URL (takes priority) */
  href?: string | null;
  /** Client ID (used with eventID to build URL) */
  clientID?: string | null;
  /** Event ID suffix (used with clientID to build URL) */
  eventID?: string | null;
  /** Size variant */
  size?: 'sm' | 'default';
}

function buildPlayerUrl(clientID: string, eventID: string): string {
  return `${PLAYER_BASE_URL}/?clientID=${clientID}&eventID=${eventID}&debug=true`;
}

export function PlayerButton({ href, clientID, eventID, size = 'sm' }: PlayerButtonProps) {
  const url = href || (clientID && eventID ? buildPlayerUrl(clientID, eventID) : null);
  if (!url) return null;

  return (
    <Button
      asChild
      size={size}
      className="gap-1.5 btn-player">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <MonitorPlay className="h-3.5 w-3.5"/>
        Open Player
      </a>
    </Button>
  );
}
